/* iter55y — Small SVG leaf-badge component used in the TitleBar and
 * the Account/Settings dialog to visualise writing milestones:
 *
 *   • silver     — 20,000 lifetime words
 *   • gold       — 40,000 lifetime words
 *   • platinum   — 60,000 lifetime words
 *   • multicolor — 80,000 lifetime words  OR  a project marked "The End"
 *                                              (via chapter.is_ending)
 *                                              at >= 20k words.
 */
import React from 'react';

const TONES = {
  silver: {
    fill:   'url(#leaf-silver-fill)',
    stops: [['0%', '#e5e7eb'], ['100%', '#9ca3af']],
    ring:   '#9ca3af',
    label:  'Silver writer',
  },
  gold: {
    fill:   'url(#leaf-gold-fill)',
    stops: [['0%', '#fde68a'], ['100%', '#d97706']],
    ring:   '#d97706',
    label:  'Gold writer',
  },
  platinum: {
    fill:   'url(#leaf-platinum-fill)',
    stops: [['0%', '#e0f2fe'], ['100%', '#0369a1']],
    ring:   '#0369a1',
    label:  'Platinum writer',
  },
  multicolor: {
    fill:   'url(#leaf-multi-fill)',
    stops: [['0%', '#f59e0b'], ['40%', '#ef4444'], ['70%', '#8b5cf6'], ['100%', '#0ea5e9']],
    ring:   '#8b5cf6',
    label:  'Novel completed',
  },
};

export default function LeafBadge({ tier, size = 14, className = '', title }) {
  const tone = TONES[tier];
  if (!tone) return null;
  const gradientId = `leaf-${tier}-fill`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      data-testid={`leaf-badge-${tier}`}
      role="img"
      aria-label={tone.label}
    >
      <title>{title || tone.label}</title>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          {tone.stops.map(([offset, color]) => (
            <stop key={offset} offset={offset} stopColor={color} />
          ))}
        </linearGradient>
      </defs>
      {/* Leaf silhouette */}
      <path
        d="M12 2C8 4 4 7 4 12c0 5 4 9 8 10 4-1 8-5 8-10 0-5-4-8-8-10z"
        fill={tone.fill}
        stroke={tone.ring}
        strokeWidth="0.8"
      />
      {/* Central vein */}
      <path
        d="M12 4 L12 20"
        stroke={tone.ring}
        strokeWidth="0.6"
        opacity="0.6"
      />
      {/* Side veins */}
      <path
        d="M12 8 L8 10 M12 12 L7 14 M12 16 L8 17 M12 8 L16 10 M12 12 L17 14 M12 16 L16 17"
        stroke={tone.ring}
        strokeWidth="0.4"
        opacity="0.4"
        fill="none"
      />
    </svg>
  );
}
